import React, { useEffect } from "react";
import CloseModalIcon from "../../../shared-components/icons/CloseModalIcon";
import { useBotbLeaderboardContext } from "../context";
import { SmarticoTournamentPrize } from "../../../interfaces/smartico";

const LeaderboardModal = () => {
  const { closePrizesModal, prizesData } = useBotbLeaderboardContext();
  useEffect(() => {
    document.querySelector("body").classList.add("!overflow-hidden");

    return () => {
      document.querySelector("body").classList.remove("!overflow-hidden");
    };
  }, []);

  const formatPlace = (place: number) => {
    switch (place) {
      case 1: {
        return "1st";
      }
      case 2: {
        return "2nd";
      }
      case 3: {
        return "3rd";
      }
      default: {
        return `${place}th`;
      }
    }
  };

  const formatPrize = (prize: SmarticoTournamentPrize) => {
    const from = formatPlace(prize.place_from);
    const to = formatPlace(prize.place_to);

    if (prize.place_from === prize.place_to) {
      return `${from} ${prize.place_from === 1 ? "place" : "places"}`;
    }
    return `${from} - ${to} ${prize.place_from === 1 ? "place" : "places"}`;
  };

  const getPrizeMultiplier = (prize: SmarticoTournamentPrize) => {
    return `${prize.place_to - prize.place_from + 1}x`;
  };

  return (
    <>
      <div data-name="Overlay" className="fixed inset-0 z-[9999] bg-black/80"></div>
      <div
        data-name="PopupContainer"
        className={"fixed inset-0 z-[99999] w-full min-h-full overflow-x-hidden overflow-y-auto"}>
        <div className={"w-full min-h-full px-3 py-[60px] flex-center flex-col m-auto"}>
          <div
            className={
              "bg-white rounded-2xl font-jost relative w-full lg:max-w-[600px] px-4 pt-10 lg:px-10 flex flex-col lg:rounded-lg"
            }>
            <button onClick={closePrizesModal} className={"absolute right-2 top-2"}>
              <CloseModalIcon className={"size-6 text-gray-5"} />
            </button>
            <div className={"font-jost"}>
              <div className={"mb-4 text-center"}>
                <div className={"mb-2 text-dark-1 text-base leading-5.5 font-semibold lg:text-2xl lg:leading-7.5"}>
                  Over 200,000 prizes are waiting for you!
                </div>
                <div className={"text-gray-1 text-sm font-normal leading-5 lg:text-base lg:leading-5.5"}>
                  This is our biggest leaderboard ever! Climb the ranks <br className="max-lg:hidden" /> to win huge
                  cash prizes.
                </div>
              </div>
              <div className={"overflow-y-auto flex flex-col gap-1 max-h-[396px] lg:max-h-[448px] no-scrollbar"}>
                {/*row start*/}
                {prizesData.map((prize, idx) => (
                  <div key={prize.id} className={"justify-between border-b border-black/8"}>
                    <div className={"p-2 flex items-center gap-2"}>
                      <div>
                        <img
                          src={`/assets/images/tournament-prizes/${idx}-image.png`}
                          alt={`prize-${idx}`}
                          width={79}
                          height={48}
                          className="object-cover w-auto h-10 rounded lg:h-12"
                        />
                      </div>
                      <div className={"flex-center flex-col w-full"}>
                        <div className={"text-gray-5 text-xs font-medium leading-4 mb-1"}>{formatPrize(prize)}</div>
                        <div className={"font-semibold text-sm leading-5 text-secondary"}>
                          <strong className={"text-primary mr-1"}>{getPrizeMultiplier(prize)}</strong>
                          <span>{prize.name}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {/*row end*/}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaderboardModal;
